import { render, staticRenderFns } from "./DetalleAdministrativeCentreFaceB2B.vue?vue&type=template&id=3bdea22b"
import script from "./DetalleAdministrativeCentreFaceB2B.vue?vue&type=script&lang=js"
export * from "./DetalleAdministrativeCentreFaceB2B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports